import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { TaxonomyTags } from 'src/app/general/taxonomies/form/parts/taxonomy-tags';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface Props extends ComponentViewProps<TaxonomyItem> {
	title: string;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	onSave: () => Promise<void>;
	onCancel: () => void;
	defaultLanguage: string;
	tags: DataSet<TaxonomyTagItem>;
	contextService: any;
}

@observer
export class TaxonomyFormView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			title, mode, onModeChange, onSave, onCancel,
			model, tags, setBusy, defaultLanguage
		} = this.props;
		const array: TabLanguageModel[] = [{
			title: 'Name',
			dynamicProperties: model.dynamicProperties['displayName'],
			required: true
		}];

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 3, span: 18 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={title}
									mode={mode}
									onModeChanged={onModeChange}
									save={onSave}
									cancel={onCancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<div className="card p-3">
									<Row gutter={16}>
										<Col xs={14}>
											<CardController
												mode={mode}
												className="card-borderless"
												icon="book"
												title="General information">
												<Row>
													<Col xs={24}>
														<TabLanguageController
															model={model}
															dynamicProperties={array}
															mode={mode}
															setBusy={setBusy}
															isRichTextBox={false}
														/>
													</Col>
												</Row>
												<Row>
													<Col xs={8}>
														<DropdownView
															required
															label="Type of Tags"
															options={[
																{ value: 'number', label: 'Number' },
																{ value: 'text', label: 'Text' }
															]}
															disabled={mode === 'display'}
															model={model.dynamicProperties.type}
															onChanged={(newValue) => {
																if (newValue != null) {
																	model.dynamicProperties.type = newValue.value;
																}
															}}
														/>
													</Col>
												</Row>
											</CardController>
										</Col>
										<Col xs={10}>
											<CardController
												mode={mode}
												icon="tags"
												className="card-borderless"
												title="Tags">
												<TaxonomyTags
													mode={mode}
													type={model.dynamicProperties.type}
													model={tags}
													defaultLanguage={defaultLanguage}
													setBusy={setBusy}
												/>
											</CardController>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxonomies/form/taxonomy-form.view.tsx